import { useEffect, useState } from "react";
import ProvinceAccordion from "../../components/Address/ProvinceAccordion";
import ProvinceModal from "../../components/Address/ProvinceModal";
import api from "../../api";

export default function RegionManagementPage() {
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState(null);

  const fetchProvinces = async () => {
    try {
      // دریافت لیست استان‌ها
      const provincesRes = await api.get('/accounts/provinces/');

      // دریافت همه شهرها
      const citiesRes = await api.get('/accounts/cities/');
      const allCities = citiesRes.data || [];

      // گروه‌بندی شهرها بر اساس province_id
      const citiesByProvince = {};
      allCities.forEach(city => {
        const provinceId = city.province;
        if (!citiesByProvince[provinceId]) {
          citiesByProvince[provinceId] = [];
        }
        citiesByProvince[provinceId].push(city);
      });

      // اضافه کردن شهرها به استان مربوطه
      const provincesWithCities = provincesRes.data.map(province => ({
        ...province,
        cities: citiesByProvince[province.id] || []
      }));

      setProvinces(provincesWithCities);
    } catch (err) {
      console.error('خطا در دریافت اطلاعات:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProvinces();
  }, []);

  const handleCreate = () => {
    setSelectedProvince(null);
    setIsModalOpen(true);
  };

  const handleEdit = async (provinceId) => {
    try {
      // دریافت اطلاعات کامل استان با شهرها
      const provinceRes = await api.get(`/accounts/provinces/${provinceId}/`);

      setSelectedProvince(provinceRes.data); // اینجا cities داخل data هست
      setIsModalOpen(true);
    } catch (err) {
      console.error('خطا در دریافت اطلاعات استان:', err);
    }
  };

  return (
    <div className="p-8 bg-gray-50 min-h-screen" dir="rtl">
      <div className="flex justify-end mb-6">
        <button
          onClick={handleCreate}
          className="bg-blue-900 text-yellow-400 px-5 py-2 rounded-lg shadow hover:opacity-90 transition"
        >
          افزودن استان
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500">در حال بارگذاری...</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {provinces.map((province) => (
            <ProvinceAccordion
              key={province.id}
              province={province}
              onEdit={handleEdit}
            />
          ))}
        </div>
      )}

      {isModalOpen && (
        <ProvinceModal
          province={selectedProvince}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedProvince(null);
          }}
          onSuccess={fetchProvinces}
        />
      )}
    </div>
  );
}